import { LoadableLazy } from '@confluence/loadable';

import type { SmartlinkAuthNudgeProps } from '../src/SmartlinkAuthNudge.tsx';

export const LazySmartlinkAuthNudge = LoadableLazy<SmartlinkAuthNudgeProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SmartlinkAuthNudge" */ '../src/SmartlinkAuthNudge.tsx'
			)
		).SmartlinkAuthNudge,
});
